if($('.frame-type-mask_ce_intro_slider').length > 0){
    $('.frame-type-mask_ce_intro_slider .slider').slick({
        arrows: false,
        dots: true,
        dotsClass: 'slick-dots ce-px-15',
        autoplay: true,
        autoplaySpeed: 5000
    });
}
/* Slider Event Page Digitalisierung */
if($('.single-event .single-event-slider').length > 0){
    $('.single-event-slider .slider').slick({
        adaptiveHeight: false,
        arrows: false,
        dots: false,
        autoplay: false
    });

    $('.cstm-slick-prev').on('click tap', function() {
        $('.single-event-slider .slider').slick('slickPrev');
    });
    $('.cstm-slick-next').on('click tap', function() {
        $('.single-event-slider .slider').slick('slickNext');
    });

}
